import {
  GET_USERINFO,
  ADD_TAB,
  DELETE_TAB,
  CLEAR_TABS,
  CLEAR_ALL_TABS,
  SET_TAB_NO_SAVE_TRUE,
  SET_TAB_NO_SAVE_FALSE,
  SET_ACTIVEID,
  OPEN_MENU,
  SET_PERMISSIONS,
  RESET_TABACTIVEID
} from './mutation-types.js'


export default {
  [GET_USERINFO](state,info){
    state.userInfo = info;
  },
  /**
   * 添加tab标签页
   * @param state
   * @param tab {title:标签名,componentName:组件名(对应pages/index中的名字),icon:图标的class名字,
   *        params:{}组件需要的参数,默认会包含一个tabId属性,isAlwaysNew:boolean是否总是新开标签}
   * @returns {boolean} 超过20个会添加失败返回false,添加成功返回true
   */
  [ADD_TAB](state,tab){
    if(state.tabsArr.length>=20){
      return false;
    }
    if(!tab.isAlwaysNew){
      let temp = state.tabsArr.find(item=>{return item.componentName===tab.componentName});
      if(temp){
        state.tabActiveId = temp.id;
        temp.params = tab.params;
        temp.params.tabId = temp.id;
        return false;
      }
    }
    if(tab.isNoSaved === undefined){
      tab.isNoSaved = false;
    }
    if(!tab.params){
      tab.params = {};
    }
    let tempTab = {
      id:new Date().getTime()+'',
      ...tab
    };
    tempTab.params.tabId = tempTab.id;
    state.tabsArr.push(tempTab);
    return true;
  },
  /**
   * 删除tab
   * @param state
   * @param tabId 需要删除的tab的id
   */
  [DELETE_TAB](state,tabId){
    state.tabsArr.forEach((tab,index,arr)=>{
      if(tab.id == tabId){
        arr.splice(index,1);
      }
    })
  },
  /**
   * 清除不要的tab
   * @param state
   * @param tabIds 需要保留的一个或多个tab的id组成的数组
   */
  [CLEAR_TABS](state,tabId){
    state.tabsArr = state.tabsArr.filter(tab=>{
      return tab.id == tabId;
    });
  },
  /**
   * 清除所有的tab
   * @param state
   */
  [CLEAR_ALL_TABS](state){
    state.tabsArr = [];
  },
  /**
   * 设置tab为未保存状态
   * @param state
   * @param tabId
   */
  [SET_TAB_NO_SAVE_TRUE](state,tabId){
    let tab = state.tabsArr.find(item => {
      return item.id === tabId
    });
    if(tab){
      tab.isNoSaved = true;
    }
  },
  /**
   * 设置tab为已保存状态
   * @param state
   * @param tabId
   */
  [SET_TAB_NO_SAVE_FALSE](state,tabId){
    let tab = state.tabsArr.find(item => {
      return item.id === tabId
    });
    if(tab){
      tab.isNoSaved = false;
    }
  },
  [RESET_TABACTIVEID](state){
    state.tabActiveId = null;
  },
  /**
   * 进入页面需要打开的侧边栏
   * @param state
   * @param menuId
   */
  [OPEN_MENU](state,menuId){
    state.openMenu = [menuId];
  },
  /**
   * 设置权限列表
   * @param state
   * @param permissions
   */
  [SET_PERMISSIONS](state,permissions){
    state.permissions = permissions;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js